import _objectSpread from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _typeof from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/typeof.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import { Message } from 'element-ui';
import axios from 'axios';
import Adapter from 'axios-mock-adapter';
import { get, isEmpty, merge } from 'lodash';
import qs from 'qs';
import util from '@/libs/util';
import store from '@/store';
import { errorLog, errorCreate } from './tools';
import { api } from '@api/env';
var md5 = require('md5');

/**
 * @description 记录和显示错误
 * @param {Error} error 错误对象
 */
function handleError(error) {
  // 添加到日志
  store.dispatch('d2admin/log/push', {
    message: '数据请求异常',
    type: 'danger',
    meta: {
      error: error
    }
  });
  // 打印到控制台
  if (process.env.NODE_ENV === 'development') {
    util.log.danger('>>>>>> Error >>>>>>');
    console.log(error);
  }
  // 显示提示
  Message({
    message: error.message,
    type: 'error',
    duration: 5 * 1000
  });
}

/**
 * @description 创建请求实例
 */
function createService() {
  // 创建一个 axios 实例
  var service = axios.create();
  // 请求拦截
  service.interceptors.request.use(function (config) {
    return config;
  }, function (error) {
    // 发送失败
    console.log(error);
    return Promise.reject(error);
  });
  // 响应拦截
  service.interceptors.response.use(function (response) {
    if (response.config.getHeaders) {
      return response;
    }
    // dataAxios 是 axios 返回数据中的 data
    var dataAxios = response.data;
    // 这个状态码是和后端约定的
    var state = dataAxios.state,
      Msg = dataAxios.Msg,
      State = dataAxios.State,
      msg = dataAxios.msg;
    var code = state;
    var text = Msg;
    if (!text) {
      text = msg;
    }
    if (code === undefined) {
      code = State;
    }
    // 根据 code 进行判断
    if (response.config.output) {
      // 如果没有 code 代表这不是项目后端开发的接口 比如可能是 D2Admin 请求最新版本
      return dataAxios;
    }
    // 有 code 代表这是一个后端接口 可以进行进一步的判断
    switch (code) {
      case 0:
        // [ 示例 ] code === 0 代表没有错误
        return dataAxios;
      case -2:
        store.commit('cpscc/logout');
        return;
      case 2:
        // [ 示例 ] 其它和后台约定的 code
        if (text === 'userinfo is missing!') {
          store.commit('cpscc/logout');
        } else {
          errorCreate(text);
        }
        break;
      default:
        if (response.status === 200 && response.data) {
          return response.data;
        } else {
          if (text) {
            errorCreate("".concat(text));
          }
        }
        break;
    }
  }, function (error) {
    var status = get(error, 'response.status');
    var data = get(error, 'response.data');
    switch (status) {
      case 400:
        if (_typeof(data.errors) === 'object') {
          var keys = Object.keys(data.errors);
          // // 数组二维转一维
          // function flatten(arr) { return [].concat( ...arr.map(x => Array.isArray(x) ? flatten(x) : x) ) }
          // error.message = flatten(errors).join(',')
          if (Array.isArray(keys) && keys.length) {
            var key = keys[0];
            // let reg = /\[(.*)\]/;
            // let res = key.match(reg);
            error.message = "".concat(key, ": ").concat(data.errors[key]);
          }
        } else {
          error.message = data ? data : '请求错误';
        }
        break;
      case 401:
        error.message = data || '未授权，请登录';
        break;
      case 403:
        error.message = data || '权限不足,拒绝访问';
        break;
      // case 404: error.message = `请求地址出错: ${error.response.config.url}`; break;
      case 404:
        error.message = data || '请求出错';
        break;
      case 405:
        store.commit('cpscc/logout');
        errorCreate('登录超时');
        break;
      case 408:
        error.message = data || '请求超时';
        break;
      case 409:
        error.message = data || '请求出错';
        break;
      case 500:
        error.message = data || '服务器内部错误';
        break;
      case 501:
        error.message = data || '服务未实现';
        break;
      case 502:
        error.message = data || '网关错误';
        break;
      case 503:
        error.message = data || '服务不可用';
        break;
      case 504:
        error.message = data || '网关超时';
        break;
      case 505:
        error.message = data || 'HTTP版本不受支持';
        break;
      default:
        break;
    }
    handleError(error);
    throw error;
  });
  return service;
}
function stringify(data) {
  return qs.stringify(data, {
    allowDots: true,
    encode: false
  });
}

/**
 * @description 创建请求方法
 * @param {Object} service axios 实例
 */
function createRequest(service) {
  return function (config) {
    var token = util.cookies.get('token');
    var tenant = util.cookies.get('tenant');
    var tenantId = util.cookies.get('tenantId');
    var headers = {};
    var withCredentials = true;
    if (config.customHeaders) {
      headers = config.customHeaders;
    }
    if (config.customWithCredentials !== undefined) {
      withCredentials = config.customWithCredentials;
    }
    var timestamp = Date.now();
    var configDefault = {
      withCredentials: withCredentials,
      baseURL: api,
      timeout: 200 * 1000,
      // 请求超时时间
      headers: _objectSpread({
        token: token,
        tenant: tenant,
        tenantId: tenantId,
        'Content-Type': get(config, 'headers.Content-Type', 'application/json'),
        timestamp: timestamp,
        sign: md5("cpscc_".concat(timestamp, "_").concat(token, "_").concat(config.url))
      }, headers),
      data: {}
    };
    var option = merge(configDefault, config);
    // // 处理 get 请求的参数
    // // 请根据实际需要修改
    // if (!isEmpty(option.params)) {
    //   option.url = option.url + '?' + stringify(option.params)
    //   option.params = {}
    // }
    // // 当需要以 form 形式发送时 处理发送的数据
    // // 请根据实际需要修改
    // if (!isEmpty(option.data) && option.headers['Content-Type'] === 'application/x-www-form-urlencoded') {
    //   option.data = stringify(option.data)
    // }
    return service(option);
  };
}

// 用于真实网络请求的实例和请求方法
export var service = createService();
export var request = createRequest(service);

// 用于模拟网络请求的实例和请求方法
export var serviceForMock = createService();
export var requestForMock = createRequest(serviceForMock);

// 网络请求数据模拟工具
export var mock = new Adapter(serviceForMock);